import React              from 'react';
import { useTranslation } from 'react-i18next';

import CompareParameter from './CompareParameter';

// Rows of one comparison group, rendered from the offers' `sections` (parameter sections and parameters
// with show_in_compare configured in the admin panel). A two-sided parameter is two rows (outside /
// inside). CompareParameter hides a row that is empty for every compared offer.
const CompareSectionRows = function(props) {
  const {
          compareOffers,
          section,
          showInfo,
          screenWidth,
        } = props;

  const { t } = useTranslation();

  const valueOf = React.useCallback((offer, rowAlias) => {
    const offerSection = (offer.sections || []).find((item) => item.alias === section.alias);
    const row          = offerSection?.rows.find((item) => item.alias === rowAlias);

    return row?.value || null;
  }, [section.alias]);

  return (
    <tbody>
    {section.rows.map((row) => (
      row.isDual
        ? ['outside', 'inside'].map((side) => (
          <CompareParameter
            key={`${row.alias}-${side}`}
            compareBest={row.compareBest}
            parameters={compareOffers}
            getParameterItem={(offer) => valueOf(offer, row.alias)?.[side] || null}
            showInfo={showInfo}
            screenWidth={screenWidth}
            title={`${row.label} ${t(`${side}_title`)}`}
          />
        ))
        : (
          <CompareParameter
            key={row.alias}
            compareBest={row.compareBest}
            parameters={compareOffers}
            getParameterItem={(offer) => valueOf(offer, row.alias)}
            showInfo={showInfo}
            screenWidth={screenWidth}
            title={row.label}
          />
        )
    ))}
    </tbody>
  );
};

export default CompareSectionRows;
